import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

export default function Loader(props) {

  return (
    <div className={`loader-container ${props.withOverlay ? 'with-overlay' : ''} ${props.className}`}>
      <span className='loader'></span>
    </div>
  )
}

Loader.defaultProps = {
  withOverlay: false
}

Loader.propTypes = {
  className: PropTypes.string,
  withOverlay: PropTypes.bool
}